import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteSegment } from '../../../../actions';

class SegmentDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteSegment, segmentId } = this.props;

    dispatchDeleteSegment({ segmentId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

SegmentDeleteButton.propTypes = {
  segmentId: PropTypes.number.isRequired,
  dispatchDeleteSegment: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteSegment: deleteSegment,
};

export default connect(null, mapDispatchToProps)(SegmentDeleteButton);
